import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppService } from '@app/app.service';
import { HighlightPageService } from '@pages/highlight-page/highlight.service';

import { Highlight } from '../adapter/highlight.adapter';

@Injectable({
  providedIn: 'root',
})
export class HighlightPageResolver implements Resolve<Observable<Highlight | null>> {
  private highlightPageService = inject(HighlightPageService);
  private router = inject(Router);
  private appService = inject(AppService);

  public resolve(route: ActivatedRouteSnapshot): Observable<Highlight | null> {
    const highlightId = route.paramMap.get('highlightId');
    return this.highlightPageService.getHighlights(highlightId).pipe(
      map((result) => {
        if (!result) {
          this.router.navigate(['404'], { skipLocationChange: true });
          return null;
        } else {
          this.appService.lightBackgroundPage();
          return result;
        }
      })
    );
  }
}
